import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import {grey, teal} from '@mui/material/colors'
import {IConcept} from 'app/models/concept'
import FavoriteButton from '../FavoriteButton'
import HorizontalSquareChips from '../HorizontalSquareChips'
import {ConceptChip} from '../concepts/ConceptChip'

export default function ConceptResultCard({
  con,
  currScrollPosition,
  search,
  fromDirectory,
  page,
}: {
  con: IConcept
  currScrollPosition?: number
  search?: string
  fromDirectory?: boolean
  page?: number
}) {
  return (
    <Grid container mb={2}>
      <Grid item xs={12} sm={12} md={12} lg={10} display='flex' alignItems={'baseline'}>
        <Box
          sx={{
            display: 'flex',
            flex: '1 1 auto',
            justifyContent: 'space-between',
            justifyItems: 'center',
            fontSize: '22px',
            alignItems: 'center',
            fontWeight: '500',
          }}
          gap={1}
        >
          <Grid container>
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <ConceptChip
                concept={con}
                link={
                  fromDirectory
                    ? `/concepts/detail?externalId=${
                        con.id
                      }&scrollPosition=${currScrollPosition}&fromConceptDirectory=${
                        search !== '' ? search : 'tru'
                      }${page ? `&page=${page}` : ''}`
                    : `/concepts/detail?externalId=${con.id}`
                }
                width='max-content'
                fs={'1em'}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={8}>
              {(con?.aliases?.length ?? 0) > 0 ? (
                <Box ml={10} color={'goldenrod'}>
                  <Typography variant={'body1'}>Aliases:</Typography>
                  <Box component={'span'}>
                    <HorizontalSquareChips
                      items={(con?.aliases as string[]) ?? []}
                      size={'small'}
                      color={teal[50]}
                      maxItems={13}
                      moreString='Show All aliases'
                      lessString='Show Less aliases'
                    />
                  </Box>
                </Box>
              ) : (
                <Typography ml={10} variant={'subtitle1'} color={grey[600]}>
                  No Aliases
                </Typography>
              )}
            </Grid>
          </Grid>
        </Box>
      </Grid>
      <Grid item xs={1}>
        {' '}
      </Grid>
      <Grid item xs={1}>
        <Box display={'flex'} justifyContent={'flex-start'} alignItems={'center'} gap={1}>
          <FavoriteButton item={con} type={'concepts'} />
        </Box>
      </Grid>
    </Grid>
  )
}
